import * as React from 'react'
import IconButton from '@mui/material/IconButton'
import NotificationsIcon from '@mui/icons-material/Notifications'

import { useNotifications } from '~/client/hooks/notifications'
import Link from '~/client/components/Link'

export default function NotificationsDropdown(props) {
  useNotifications()
  return <IconButton
    {...props}
    component={Link}
    to="/notifications"
  >
    <NotificationsIcon/>
  </IconButton>
}
